module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isProspect),
      expression: "!isProspect"
    }]
  }, [_c('div', [_vm._v("Installation fees are currently waived.")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('label', [_vm._v("When would you like your installation to occur? Note that Bonfire will call you beforehand to confirm or update your activation time.")]), _vm._v(" "), _c('b-form-datepicker', {
    attrs: {
      "min": _vm.min_date
    },
    model: {
      value: (_vm.form_data.desired_activation_date),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "desired_activation_date", $$v)
      },
      expression: "form_data.desired_activation_date"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Desired activation date")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ea1f48a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/create/BonfireResidential.vue
// module id = 1335
// module chunks = 16